import styled from "styled-components";
import { commonClientBalanceCardStyle } from "../../atom";

export const PictureNormalRechargeWrapper = styled.div`
  position: relative;
`;
export const PictureNormalRechargeCard = styled(commonClientBalanceCardStyle)``;
